import { render, staticRenderFns } from "./onlinepayments.vue?vue&type=template&id=54161ede&"
import script from "./onlinepayments.vue?vue&type=script&lang=js&"
export * from "./onlinepayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports